import { useEffect, useRef, useState } from "react";
import "./App.css";
import ZoomableMap from "./components/ZomableMap";
import Image from "./components/Image";
import Video from "./components/Video";
import Stats from "./components/Stats";
import Splits from "./components/Splits";
import { TextParagraph, TextInsert, TextSection } from "./components/Text";
import FooterIcon from "./components/GitHubFooter";

import legs from "./data/contentData";
import { splitTimes, legSplits } from "./data/splitData";

function useInViewAnimation(ref) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          el.classList.add("visible");
          observer.disconnect();
        }
      },
      { threshold: 0.05 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
  return isVisible;
}

function LegSection({ leg, legIndex, splitTimes }) {
  const ref = useRef(null);
  const isVisible = useInViewAnimation(ref);

  return (
    <section ref={ref} className="leg">
      <div className="content">
        <h2>
          {leg.title} - {leg.runnerName}
        </h2>

        <Image src={leg.runnerImage}></Image>

        <TextSection title={leg.text[0].desc}>
          <TextParagraph>{leg.text[0].content}</TextParagraph>
        </TextSection>
        {leg.text[1] && (
          <TextSection title={leg.text[1].desc}>
            <TextParagraph>{leg.text[1].content}</TextParagraph>
          </TextSection>
        )}

        {splitTimes && <Splits data={splitTimes}></Splits>}

        <TextInsert>
          <ZoomableMap
            leg={leg}
            imagePath={leg.gpsMapPath}
            gpsLink={leg.gpsLink}
            isVisible={isVisible}
          />
        </TextInsert>

        <TextSection title={leg.text[2].desc}>
          <TextParagraph>{leg.text[2].content}</TextParagraph>
        </TextSection>
        {leg.text[3] && (
          <TextSection title={leg.text[3].desc}>
            <TextParagraph>{leg.text[3].content}</TextParagraph>
          </TextSection>
        )}
        <Image src={leg.graphImage} caption={leg.graphCaption}></Image>
        <Stats stats={legSplits} index={leg.index}></Stats>
      </div>
    </section>
  );
}

function BottomText() {
  const ref = useRef(null);
  useInViewAnimation(ref);

  return (
    <section ref={ref} className="leg">
      <div className="content">
        <Video></Video>
      </div>
      <FooterIcon></FooterIcon>
    </section>
  );
}

export default function Page() {
  return (
    <main className="container">
      <header className="header">
        <h1>Hvordan vinne 10MILA </h1>
        <Image src="Lagbilde.jpg"></Image>
        <div className="content">
          <p>
            Her er oppskriften på hvordan NTNUI vant 10mila i 2025. Her er det
            mange godbiter og kloke ord med råd og inspirasjon til neste gang vi
            skal vinne.
          </p>
          <br />
          <p>
            Tusen takk til Laura som har hentet bilder, og ordnet all teksten.
          </p>
          <br />
          Hu og Hei
        </div>
      </header>

      {legs.map((leg, i) => (
        <LegSection key={leg.id} leg={leg} splitTimes={splitTimes[i]} />
      ))}

      <BottomText></BottomText>
    </main>
  );
}
